import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Section = styled.section`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: var(--dark);
  padding: 8rem 2.5rem 6rem;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, var(--gray-1), transparent);
  }
`;

const Eyebrow = styled(motion.p)`
  font-size: 0.72rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--gray-3);
  font-weight: 500;
  margin-bottom: 1.5rem;
`;

const Title = styled(motion.h1)`
  font-size: clamp(2.8rem, 7vw, 5rem);
  font-weight: 700;
  letter-spacing: -0.04em;
  line-height: 1.05;
  color: var(--white);
  margin-bottom: 1.5rem;
  max-width: 700px;
`;

const Subtitle = styled(motion.p)`
  font-size: clamp(1rem, 2vw, 1.2rem);
  color: var(--gray-3);
  font-weight: 300;
  line-height: 1.65;
  max-width: 440px;
`;

const Scroll = styled(motion.a)`
  position: absolute;
  bottom: 2.5rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
`;

const ScrollText = styled.span`
  font-size: 0.65rem;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: var(--gray-3);
`;

const ScrollLine = styled.div`
  width: 1px;
  height: 32px;
  background: linear-gradient(to bottom, var(--gray-3), transparent);
`;

const Hero = () => {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <Section id="hjem">
      <Eyebrow
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        Holdingselskap
      </Eyebrow>
      <Title
        initial={{ opacity: 0, y: 25 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.1 }}
      >
        Andreassen Kapital
      </Title>
      <Subtitle
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.25 }}
      >
        Privat holdingselskap som investerer i teknologi og vekstselskaper.
      </Subtitle>

      <Scroll
        onClick={() => go('om')}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 0.8 }}
      >
        <ScrollText>Scroll</ScrollText>
        <ScrollLine />
      </Scroll>
    </Section>
  );
};

export default Hero;
